import React from "react";
import { Link } from "react-router-dom";
import usePlatformLogo from "../hooks/usePlatformLogo";

export default function AuthPageLogo() {
  const logoUrl = usePlatformLogo();

  return (
    <Link to="/home" className="auth-page-logo-link" aria-label="Trocanet home">
      <img src={logoUrl} alt="Trocanet" className="auth-page-logo" />
    </Link>
  );
}
